/**
 *
 * ShowSelected search result
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import L from 'leaflet';
import { withLeaflet, CircleMarker, GeoJSON } from 'react-leaflet';
import withSearch from 'containers/GeoSearch/withSearch';
import getPadding from 'utils/getPadding';
import { searchColor } from 'styles/colors';

// import { FormattedMessage } from 'react-intl';

class ShowSelected extends React.PureComponent {
  constructor(props) {
    super(props);
    const color = searchColor;
    const style = {
      color,
      fillColor: color,
    };
    this.circleOptions = { ...style, interactive: false };
    const pointToLayer = (geoJsonPoint, latlng) =>
      L.circleMarker(latlng, this.circleOptions);
    this.geoJsonOptions = { style, pointToLayer, interactive: false };
  }
  componentDidMount() {
    const { geoSelected } = this.props;
    this.selected = geoSelected;
    if (geoSelected) {
      this.setMap();
    }
  }

  componentDidUpdate() {
    const { geoSelected } = this.props;
    if (geoSelected !== this.selected) {
      this.selected = geoSelected;
      if (geoSelected) {
        this.setMap();
      }
    }
  }

  setMap() {
    const { leaflet, geoSelected } = this.props;
    if (geoSelected.bounds) {
      leaflet.map.fitBounds(geoSelected.bounds, {
        ...getPadding(),
        maxZoom: 16,
      });
    } else {
      leaflet.map.setView(geoSelected.position, 16);
    }
  }

  render() {
    const { geoSelected } = this.props;
    if (!geoSelected) {
      return null;
    }
    return geoSelected.geojson ? (
      <GeoJSON
        key={geoSelected.id}
        data={geoSelected.geojson}
        {...this.geoJsonOptions}
      />
    ) : (
      <CircleMarker center={geoSelected.position} {...this.circleOptions} />
    );
  }
}

ShowSelected.propTypes = {
  leaflet: PropTypes.object.isRequired,
  geoSelected: PropTypes.object,
};

export default compose(
  withLeaflet,
  withSearch,
)(ShowSelected);
